var _rect, _rect2, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMenuBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 812,
    viewBox: "0 0 188 812",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 811,
    transform: "translate(0 1)",
    fill: "black",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 812,
    width: 811,
    height: 376,
    transform: "rotate(-90 0 812)",
    fill: "url(#paint0_linear_19383_56666)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.52,
    filter: "url(#filter0_f_19383_56666)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5,
    cy: -22,
    rx: 279.5,
    ry: 266,
    fill: "#5200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5 -287.5C202.611 -287.5 327.5 -168.609 327.5 -22C327.5 124.609 202.611 243.5 48.5 243.5C-105.611 243.5 -230.5 124.609 -230.5 -22C-230.5 -168.609 -105.611 -287.5 48.5 -287.5Z",
    stroke: "#5200FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    filter: "url(#filter1_f_19383_56666)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 138.253,
    cy: -23.747,
    r: 267.253,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_f_19383_56666)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.646,
    cy: 590.658,
    rx: 274.646,
    ry: 230.658,
    fill: "#5200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.646 360.37C275.187 360.37 397.922 463.531 397.922 590.658C397.922 717.785 275.187 820.946 123.646 820.946C-27.896 820.946 -150.63 717.785 -150.63 590.658C-150.63 463.531 -27.896 360.37 123.646 360.37Z",
    stroke: "#5200FF",
    strokeWidth: 0.739289
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_19383_56666",
    x: -731,
    y: -788,
    width: 1559,
    height: 1532,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_19383_56666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_19383_56666",
    x: -498.645,
    y: -660.645,
    width: 1273.79,
    height: 1273.79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 184.822,
    result: "effect1_foregroundBlur_19383_56666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_19383_56666",
    x: -520.645,
    y: -9.6445,
    width: 1288.58,
    height: 1200.61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 184.822,
    result: "effect1_foregroundBlur_19383_56666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19383_56666",
    x1: 405.5,
    y1: 733.275,
    x2: 405.5,
    y2: 1259.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12132F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12132F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12132F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuBackground);
export default __webpack_public_path__ + "static/media/mobileMenuBackground.83e5dcbe4ecd93539704956435cbbfdf.svg";
export { ForwardRef as ReactComponent };